import React, { useState } from "react";
import AppraisalFormDialog from "./AppraisalFormDialog";
import { formatDate } from "../../../../utilities/formatters";


function AppraisalFormContainer({ formTitle, onSave, onClose, data = {}, ...props }) {
    const [title, setTitle] = useState(data.title || "");
    const [appraiser, setAppraiser] = useState((data?.appraiser && data.appraiser[0]) || "");
    const [meetingDate, setMeetingDate] = useState((data.meeting && data.meeting.date) || "");
    const [meetingNotes, setMeetingNotes] = useState((data.meeting && data.meeting.notes) || "");

    const minDate = data.cycle?.start ?? "2000-01-01 00:00:00";

    const handleSubmit = () => {
        const params = {
            title,
            appraiser: [appraiser],
            meeting: {
                date: formatDate(meetingDate),
                notes: meetingNotes
            }
        };
        onSave(params);
        onClose();
    };

    return (
        <AppraisalFormDialog
            formTitle={formTitle}
            onClose={onClose}
            onSubmit={handleSubmit}
            title={title}
            setTitle={setTitle}
            appraiser={appraiser}
            setAppraiser={setAppraiser}
            meetingDate={meetingDate}
            setMeetingDate={setMeetingDate}
            minDate={minDate}
            meetingNotes={meetingNotes}
            setMeetingNotes={setMeetingNotes}
            scroll="paper"
            {...props}
        />
    );
}

export default AppraisalFormContainer;
